<div class='server-side-filter' *ngIf='predefinedFiltersService.hasFilters'>
  <div fxLayout='row'>
    <div class='bold padding-l-10 padding-r-10' style='margin-top: 4px'>
      <small>{{ 'GENERIC.filters' | translate }}</small>
    </div>

    <!-- Hosts chip list -->
    <mat-chip-list class='chip-host'>
      <mat-chip *ngFor='let filter of activeFilters' [matTooltip]='filter.name'>
        <small>{{ filter.name }}</small>
        <mat-icon matChipRemove (click)='predefinedFiltersService.disableFilters(filter.value)'>close</mat-icon>
      </mat-chip>
    </mat-chip-list>

    <!-- Hosting the static Add chip button -->
    <mat-chip-list style='min-width: 91px'>
      <mat-chip class='add-chip' vrm-button (click)='displayServerFiltersModal()'>
        <small>{{ 'GENERIC.add' | translate | uppercase }} &nbsp;</small>
        <mat-icon>add_circle_outline</mat-icon>
      </mat-chip>
    </mat-chip-list>
  </div>
</div>
